import _ from 'lodash';
import api from '../../api';
import http from '../../http';
import firebase, { auth } from '../../firebase';
import router from '../../router';
import EventBus from '../../event_bus';

const handleExceptions = function(context, error) {
  if (process.env.NODE_ENV == 'development') {
    console.log({ code: error.code, error: error });
  }
  switch (error.code) {
    case 'auth/email-already-in-use':
    case 'auth/invalid-email':
    case 'auth/operation-not-allowed':
    case 'auth/user-not-found':
      context.commit('errors/put', { key: 'email', value: error.message }, { root: true });
      break;
    case 'auth/wrong-password':
    case 'auth/weak-password':
      context.commit('errors/put', { key: 'password', value: error.message }, { root: true });
      break;
    case 'auth/invalid-phone-number':
    case 'auth/phone-number-already-exists':
      context.commit('errors/put', { key: 'phone_number', value: error.message }, { root: true });
      break;
    default:
      context.commit('errors/put', { key: 'email', value: error.message }, { root: true });
      break;
  }
};

const state = {
  token: localStorage.getItem('token') || null,
  refresh_token: localStorage.getItem('refresh_token') || null,
  expires_at: localStorage.getItem('expires_at'),
  authenticated: !!localStorage.getItem('token'),
  user: localStorage.getItem('user') || null,
  attempting: false,
  errors: false,
  last_route: '/',
  waiting_confirmation: null,
  reseting_password: false,
  pasword_reset_sent: false,
  pending_for_sync: null,
};

const getters = {
  check(state) {
    return state.user;
  },
};

const actions = {
  register(context, payload) {
    let email = _.get(payload, 'email', null);
    let password = _.get(payload, 'password', null);

    /** @Promise<UserCredential> */
    let promise = auth.signUpWithPassword(email, password);
    promise
      .then((user) => {
        setTimeout(() => {
          // A little callback hell here...
          api.user
            .me(user.uid)
            .then((response) => {
              if (response.data.uuid === undefined) {
                context.commit(
                  'errors/put',
                  {
                    key: 'email',
                    value:
                      'Registration completed successfully. Because of an error you need to log in now manually.',
                  },
                  { root: true }
                );
                context.commit('fail');
                return;
              }
              user = Object.assign(user, { uuid: response.data.uuid });
              context.commit('login', user);
              context.commit('errors/clear', null, { root: true });
            })
            .catch(() => {
              context.commit(
                'errors/put',
                { key: 'email', value: 'Service temporary unavailable' },
                { root: true }
              );
              context.commit('fail');
            });

          auth.sendEmailVerification();
        }, 500);
      })
      .catch((error) => {
        handleExceptions(context, error);
      });
  },

  login(context, payload) {
    context.commit('attempt');

    context.commit('errors/clear', null, { root: true });

    let provider = payload.provider;
    let promise = null;

    if (provider == 'google') {
      promise = auth.signInWithGoogle();
    }
    if (provider == 'facebook') {
      promise = auth.signInWithFacebook();
    }
    if (provider == 'password') {
      let email = _.get(payload, 'email', null);
      let password = _.get(payload, 'password', null);
      promise = auth.signInWithPassword(email, password);
    }
    if (provider == 'phone') {
      let phone_number = _.get(payload, 'phone_number', null);
      auth
        .signInWithPhoneNumber(phone_number)
        .then(function(confirmationResult) {
          context.commit('setConfirmation', confirmationResult);
        })
        .catch(function(error) {
          context.commit('fail');
          handleExceptions(context, error);
        });

      return;
    }

    // If still need confirmation we can stop here..
    if (!promise) return;

    promise
      .then(function(user) {
        // A little DRY / callback hell here...

        if (context.state.pending_for_sync) {
          let pending_cred = context.state.pending_for_sync.credential;
          let current_user = auth.getCurrentUser();

          current_user
            .linkWithCredential(pending_cred)
            .then((user_credential) => {
              // ...
              api.user
                .me(user.uid)
                .then((response) => {
                  user = Object.assign(user, { uuid: response.data.uuid });
                  context.commit('login', user);
                })
                .catch(() => {
                  context.commit(
                    'errors/put',
                    { key: 'email', value: 'User not found' },
                    { root: true }
                  );
                  context.commit('fail');
                });
            })
            .catch((error) => {
              context.commit('errors/put', { key: 'sync', value: error.message }, { root: true });
              context.commit('fail');
            });
        } else {
          // ...
          api.user
            .me(user.uid)
            .then((response) => {
              user = Object.assign(user, { uuid: response.data.uuid });
              context.commit('login', user);
            })
            .catch(() => {
              context.commit(
                'errors/put',
                { key: 'email', value: 'User not found' },
                { root: true }
              );
              context.commit('fail');
            });
        }
      })
      .catch(function(error) {
        if (
          context.state.pending_for_sync == null &&
          error.code == 'auth/account-exists-with-different-credential'
        ) {
          firebase
            .auth()
            .fetchSignInMethodsForEmail(error.email)
            .then((methods) => {
              // let message = error.message;
              // error.message = message + ' You can sign in using ' + methods.join(', ') + ' (' + email + ').' ;
              context.commit('fail');
              handleExceptions(context, error);

              context.commit('attemptSyncing', {
                email: error.email,
                credential: error.credential,
                methods: methods,
                provider: provider,
              });
            })
            .catch(() => {
              context.commit(
                'errors/put',
                { key: 'email', value: 'User not found' },
                { root: true }
              );
              context.commit('fail');
            });
        } else {
          context.commit('fail');
          handleExceptions(context, error);
        }
      });
  },

  logout(context) {
    // cancel all pending XHR and redirect to login.
    http.cancelAll();

    api.user.logout(context.state.user);

    auth
      .logout()
      .then(function(result) {
        context.commit('logout');
      })
      .catch(function(error) {
        context.commit('putErrorMessages', error, { root: true });
      });
  },

  confirm: function(context, code) {
    let confirmationResult = context.state.waiting_confirmation;
    if (confirmationResult) {
      let promise = auth.confirmSignIn(confirmationResult, code);
      promise
        .then(function(user) {
          // A little DRY / callback hell here...
          api.user
            .me(user.uid)
            .then((response) => {
              user = Object.assign(user, { uuid: response.data.uuid });
              context.commit('login', user);
              context.commit('errors/clear', null, { root: true });
            })
            .catch(() => {
              context.commit(
                'errors/put',
                { key: 'email', value: 'User not found' },
                { root: true }
              );
              context.commit('fail');
            });
        })
        .catch(function(error) {
          context.commit('fail');
          handleExceptions(context, error);
        });
    }
  },

  cancelConfirm: function(context, code) {
    if (context.state.waiting_confirmation != null) {
      context.commit('setConfirmation', null);
      window.recaptchaVerifier.clear();
    }
  },

  sendPasswordResetEmail: function(context, email) {
    let promise = auth.sendPasswordResetEmail(email);

    context.commit('beginResetingPassword', email);

    return promise
      .then((result) => {
        // The "result" is actually undefined.
        context.commit('successResetingPassword', result);
        // After N seconds can retry.
        setTimeout(() => {
          context.commit('clearResetingPassword');
        }, 30 * 1000);
      })
      .catch((error) => {
        handleExceptions(context, error);
        context.commit('failedResetingPassword', error);
      });
  },

  cancelSync: function(context) {
    context.commit('syncCanceled');
  },

  refresh: function(context, payload) {
    let user = payload;
    api.user
      .me(user.uid)
      .then((response) => {
        user = Object.assign(user, { uuid: response.data.uuid });
        context.commit('refresh', user);
      })
      .catch(() => {
        context.commit('errors/put', { key: 'email', value: 'User not found' }, { root: true });
        context.commit('fail');
      });
  },
};

const mutations = {
  attempt(state, response) {
    state.authenticated = false;
    state.attempting = true;

    state.user = null;
    state.token = null;
    state.refresh_token = null;
    state.expires_at = null;
  },

  login(state, user) {
    state.authenticated = true;
    state.attempting = false;
    state.waiting_confirmation = null;

    // ++
    state.pending_for_sync = null;

    state.user = user.uuid;
    state.token = user.stsTokenManager.accessToken;
    state.refresh_token = user.stsTokenManager.refreshToken;
    state.expires_at = user.stsTokenManager.expirationTime;

    localStorage.setItem('user', state.user);
    localStorage.setItem('token', state.token);
    localStorage.setItem('refresh_token', state.refresh_token);
    localStorage.setItem('expires_at', state.expires_at);

    EventBus.$emit('login', user.uuid);
  },

  refresh(state, user) {
    state.authenticated = true;
    state.attempting = false;

    state.user = user.uuid;
    state.token = user.stsTokenManager.accessToken;
    state.refresh_token = user.stsTokenManager.refreshToken;
    state.expires_at = user.stsTokenManager.expirationTime;

    localStorage.setItem('user', state.user);
    localStorage.setItem('token', state.token);
    localStorage.setItem('refresh_token', state.refresh_token);
    localStorage.setItem('expires_at', state.expires_at);
  },

  fail(state, errors) {
    state.authenticated = false;
    state.attempting = false;
    state.waiting_confirmation = null;

    state.user = null;
    state.token = null;
    state.refresh_token = null;
    state.expires_at = null;
  },

  logout(state) {
    state.authenticated = false;
    state.attempting = false;

    state.user = null;
    state.token = null;
    state.refresh_token = null;
    state.expires_at = null;

    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('expires_at');

    // In some cases better to redirect back to index page...
    let requiresAuth = _.get(router.app.$route, 'meta.requiresAuth', false);
    if (requiresAuth) {
      router.replace('/');
    }

    // And dont't forget to clear data from previous session...
  },

  setConfirmation(state, confirmationResult) {
    state.waiting_confirmation = confirmationResult;
  },

  beginResetingPassword(state) {
    state.reseting_password = true;
    state.pasword_reset_sent = false;
  },

  successResetingPassword(state) {
    state.reseting_password = false;
    state.pasword_reset_sent = true;
  },

  failedResetingPassword(state) {
    state.reseting_password = false;
    state.pasword_reset_sent = false;
  },

  clearResetingPassword(state) {
    state.reseting_password = false;
    state.pasword_reset_sent = false;
  },

  attemptSyncing(state, payload) {
    state.pending_for_sync = payload;
  },

  syncCanceled(state) {
    state.pending_for_sync = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
